import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { TrainingVersionDto } from '@api/models/training/TrainingVersionDto';
import { trainingVersionService } from '@api/services/services';

export type TrainingVersionListState = ListType<TrainingVersionDto, ListFilter>;

const initialState: TrainingVersionListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'validFrom',
    sortDesc: false,
  },
};

export const trainingVersionListSlice = listSlice({
  name: 'trainingVersionList',
  initialState,
});

export const selectTrainingVersionList = (state: RootState) => state.trainingVersionList;
export const trainingVersionListActions = trainingVersionListSlice.actions;

export const getTrainingVersionList = (trainingId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectTrainingVersionList(storeState);

  const handleGetData = (size: number) => {
    return trainingVersionService.query(
      {
        trainingId: trainingId,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken as any },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: trainingVersionListActions,
    getData: handleGetData,
  });
};
